// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__31JwR","boxTitle":"Qualiphy_boxTitle__3uE5v","box":"Qualiphy_box___HzLd","toggleWrap":"Qualiphy_toggleWrap__24oHN"};